import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Footer from "../../components/Footer/Footer";
import { ContactForm } from "../../components/Form/Form";
import { FaPhone, FaMobileAlt, FaFax, FaMapMarkerAlt } from "react-icons/fa";
import "./Contact.css";

const Contact = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        } else {
          entry.target.classList.remove("show");
        }
      });
    });

    const hiddenElements = document.querySelectorAll(".hidden");
    hiddenElements.forEach((element) => {
      observer.observe(element);
    });

    return () => {
      hiddenElements.forEach((element) => observer.unobserve(element));
    };
  }, []);

  return (
    <>
      <div className="header-margin">
        {/* Location Section */}
        <section className="section section--full">
          <div className="container">
            <h2 className="section-title hidden">{t("contact.locationTitle")}</h2>
            <div className="contact-map-wrapper hidden">
              <div className="contact-map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3313.5163590663765!2d35.50482227597618!3d33.85058117323355!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151f175ecd2b8c6f%3A0x307ea70eaaf7d498!2sSTARGATE!5e0!3m2!1sen!2slb!4v1767393618319!5m2!1sen!2slb"
                  title="map"
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Info Section */}
        <section className="section section--accent">
          <div className="container">
            <div className="contact-info-grid hidden">
              <div className="contact-info-item">
                <div className="contact-info-icon">
                  <FaMapMarkerAlt />
                </div>
                <h3>{t("contact.locationTitle")}</h3>
                <p>{t("contact.address")}</p>
              </div>
              <div className="contact-info-item">
                <div className="contact-info-icon">
                  <FaPhone />
                </div>
                <h3>{t("contact.phoneLabel")}</h3>
                <p>{t("contact.phone")}</p>
              </div>
              <div className="contact-info-item">
                <div className="contact-info-icon">
                  <FaMobileAlt />
                </div>
                <h3>{t("contact.mobileLabel")}</h3>
                <p>{t("contact.mobile")}</p>
              </div>
              <div className="contact-info-item">
                <div className="contact-info-icon">
                  <FaFax />
                </div>
                <h3>{t("contact.faxLabel")}</h3>
                <p>{t("contact.fax")}</p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Form Section */}
        <section className="section section--accent">
          <div className="container">
            <h2 className="section-title hidden">{t("contact.suggestTitle")}</h2>
            <div className="contact-form-wrapper hidden">
              <ContactForm />
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
